<template>
  <v-container :class="$platform.isMobile() ? 'px-10' : ''" fill-height grid-list-md text-xs-center>
    <v-row justify="center" style="margin: 0px">
      <v-col cols="12" sm="8" md="6" lg="5">
        <v-row style="padding: 100px 0px 10px 0px">
          <div>
            <span class="title-login">Nova senha</span>
          </div>
          <div class="mt-2 mb-10">
            <span class="darkGray--text">Defina a nova senha de acesso ao painel administrativo.</span>
          </div>
        </v-row>

        <v-alert v-if="!token" type="warning" outlined>
          Link inválido. Peça um novo link em "Esqueci minha senha" na tela de login.
        </v-alert>

        <v-form v-else ref="form" v-model="validForm" @submit.prevent="save">
          <v-text-field outlined label="Nova senha" :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword"
            :rules="[$rules.required, strongPassword]" v-model="password" hide-details="auto" class="mb-4">
          </v-text-field>
          <v-text-field outlined label="Confirme a nova senha" :type="showPassword ? 'text' : 'password'"
            :rules="[$rules.required, (v) => v === password || 'As senhas não conferem']" v-model="confirmation"
            hide-details="auto" class="mb-4">
          </v-text-field>
          <p class="darkGray--text text-caption">
            Pelo menos 8 caracteres, com letras maiúsculas e minúsculas, número e caractere especial.
          </p>
          <v-btn large color="primary" elevation="2" :loading="loading" type="submit">Salvar nova senha</v-btn>
        </v-form>

        <div class="mt-6">
          <router-link to="/login" class="btn-forgot-password">Voltar para o login</router-link>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "ResetPassword",

  data: () => ({
    validForm: true,
    loading: false,
    showPassword: false,
    password: "",
    confirmation: "",
  }),

  computed: {
    token() {
      // Links antigos chegavam sem codificação e o "+" do token virava espaço.
      const token = this.$route.query.recoveryToken;
      return token ? String(token).replace(/ /g, "+") : null;
    },
  },

  methods: {
    strongPassword(value) {
      if (!value) return true;
      return (
        (value.length >= 8 && /[a-z]/.test(value) && /[A-Z]/.test(value) && /[0-9]/.test(value) && /\W|_/.test(value)) ||
        "A senha não atende aos requisitos"
      );
    },

    async save() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      try {
        await axios.post("/api/admin/change-password", { token: this.token, password: this.password });

        this.$dialog.notify.info("Senha alterada com sucesso! Entre com a nova senha.", { position: "top-right", timeout: 4000 });
        this.$router.replace("/login");
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error) || "Não foi possível alterar a senha. O link pode ter expirado.", {
          position: "top-right",
          timeout: 5000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.btn-forgot-password {
  font-size: 14px;
  color: #9fa1a4;
  font-weight: 400;
}

.title-login {
  color: var(--v-black-base);
  font-family: 'Avenir LT Std';
  font-size: 44px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
}
</style>
